// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2i-q";
export var animationRelative = "_2i-p";
export var backdropBlur = "_2i-0";
export var detailLabelCell = "_2i-12";
export var detailTable = "_2i-11";
export var detailValueCell = "_2i-13";
export var docIconBox = "_2i-1d";
export var docIconBoxMd = "_2i-1f";
export var docIconBoxSm = "_2i-1e";
export var docTypeRow = "_2i-16";
export var docTypeRowInner = "_2i-17";
export var dropdownMatchDatePicker = "_2i-3";
export var evidenceCardContent = "_2i-1c";
export var fileUploadSpin = "_2i-j";
export var gorgiasOpenButton = "_2i-15 _2i-d";
export var gorgiasTicketCard = "_2i-14";
export var heroModalFooterButton = "_2i-18";
export var hiddenContainer = "_2i-o";
export var iconPrimary = "_2i-1g";
export var iconSecondary = "_2i-1h";
export var iconTertiary = "_2i-1i";
export var integrationCard = "_2i-1";
export var integrationLogoBox = "_2i-2";
export var mainColumnSticky = "_2i-1b";
export var maxWidthContainer = "_2i-19";
export var modalContentBody = "_2i-a";
export var modalHeaderImage = "_2i-5";
export var modalImageLabel = "_2i-7";
export var modalImageOverlay = "_2i-6";
export var modalImageSubtitle = "_2i-9";
export var modalImageTitle = "_2i-8";
export var modalImageWrapper = "_2i-4";
export var modalStickyFooter = "_2i-b";
export var removeButton = "_2i-e";
export var sidebarColumn = "_2i-1a";
export var spinner = "_2i-i";
export var timelineLine = "_2i-y";
export var timelineLineBlack = "_2i-10 _2i-y";
export var timelineLineGray = "_2i-z _2i-y";
export var timelineLineHeight = "_2i-x";
export var tlDotActivate = "_2i-u";
export var tlDotActivateAnim = "_2i-t";
export var tlDotHide = "_2i-s";
export var tlDotHideAnim = "_2i-r";
export var tlLineActivate = "_2i-w";
export var tlLineActivateAnim = "_2i-v";
export var uploadHint = "_2i-n";
export var uploadIconBox = "_2i-k";
export var uploadLabel = "_2i-m";
export var uploadText = "_2i-l";
export var uploadZone = "_2i-f";
export var uploadZoneCursorDefault = "_2i-h";
export var uploadZoneCursorPointer = "_2i-g";
export var uploadedFileRow = "_2i-c";
export var viewButton = "_2i-d";